
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M41.582 40.77l46.802 118.806a4 4 0 007.644-.681l10.955-54.774a4 4 0 013.138-3.138l54.774-10.955a4 4 0 00.681-7.644L46.77 35.582a4 4 0 00-5.187 5.187z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    